import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { connectCurrentRefinements } from 'react-instantsearch-dom'

const CurrentRefinements = ({ items, refine, isSearchStalled, createURL, hideFirst }) => {
  const { messages } = useIntl()
  return (
    <>
      {!isSearchStalled && (
        <div id='filter' className='mb-4'>
          {((!hideFirst && items.length > 0) || (hideFirst && items.length > 1)) && (
            <span>
              <FormattedMessage id='filtered-by' />:{' '}
            </span>
          )}

          {items.map(item => (
            <React.Fragment key={item.label}>
              {item.items ? (
                <React.Fragment>
                  {item.items.map(nested => (
                    <a
                      key={nested.label}
                      href={createURL(nested.value)}
                      onClick={event => {
                        event.preventDefault()
                        refine(nested.value)
                      }}
                      className='inline-flex items-center px-3 py-1 m-1 rounded-lg text-sm font-bold bg-blue hover:bg-red text-white tracking-wider uppercase'
                    >
                      {item.attribute === 'type' || item.attribute === 'activityType'
                        ? messages[nested.label.replace(/\W/g, '').toLowerCase()]
                        : nested.label}
                      <button type='button' className='flex-shrink-0 ml-3 inline-flex'>
                        <svg className='h-2 w-2' stroke='currentColor' fill='none' viewBox='0 0 8 8'>
                          <path strokeLinecap='round' strokeWidth='1.5' d='M1 1l6 6m0-6L1 7' />
                        </svg>
                      </button>
                    </a>
                  ))}
                </React.Fragment>
              ) : (
                <a
                  href={createURL(item.value)}
                  onClick={event => {
                    event.preventDefault()
                    refine(item.value)
                  }}
                >
                  {item.attribute === 'type' || item.attribute === 'activityType'
                    ? messages[item.label.replace(/\W/g, '').toLowerCase()]
                    : item.label}
                </a>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
    </>
  )
}

export default connectCurrentRefinements(CurrentRefinements)
